import { render, staticRenderFns } from "./date-table.vue?vue&type=template&id=58792534&scoped=true"
import script from "./date-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./date-table.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./date-table.vue?vue&type=style&index=0&id=58792534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58792534",
  null
  
)

export default component.exports